(function () {
  if (window.Shopify && window.Shopify.designMode) return;

  function initialize(element) {
    if (element.tagName === "IMG") {
      if (!element.hasAttribute("data-home-image")) return;
      const srcset =
        element.getAttribute("data-srcset") ||
        element.getAttribute("data-home-srcset");
      element.setAttribute("srcset", srcset);
      element.setAttribute("src", element.getAttribute("data-home-src"));
      element.removeAttribute("data-home-image");
      element.removeAttribute("data-home-src");
      element.removeAttribute("data-home-srcset");
      return;
    }

    element.classList.remove("flickityt4s-later");
    if (!element.classList.contains("flickityt4s-enabled")) {
      element.flickityt4s = new window.T4SThemeSP.Carousel(element);
    }
  }

  function start() {
    const elements = document.querySelectorAll(
      "#MainContent .flickityt4s-later, #MainContent [data-home-image]",
    );
    if (!("IntersectionObserver" in window)) {
      elements.forEach(initialize);
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            observer.unobserve(entry.target);
            initialize(entry.target);
          }
        });
      },
      { rootMargin: "300px" },
    );
    elements.forEach((element) => observer.observe(element));
  }

  if (
    document.readyState === "complete" ||
    (document.readyState !== "loading" &&
      window.T4SThemeSP &&
      window.T4SThemeSP.Carousel)
  ) {
    start();
  } else {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  }
})();
